import React, { Component } from 'react';
// import './gz.css';

class Gz extends Component {
  render() {
    return (
      <div className="rainbowContainer">
        <div className="rainbowOne" />
        <div className="rainbowTwo" />
        <div className="rainbowFive" />
        <div className="rainbowThree" />
        <div className="rainbowFour" />
        <div className="rainbowSix" />
        <div className="rainbowSeven" />
        <div className="rainbowEight" />
        <div className="rainbowNine" />
        <div className="rainbowTen" />
      </div>
    );
  }
}

export default Gz;
